module.exports = __webpack_public_path__ + "images/emoji/banana.f5bfa60cf4547b4b1d0c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/banana.png
// module id = 6cmL
// module chunks = 1